import { useQuery, keepPreviousData as previousPlaceholder } from '@tanstack/react-query';

import { useApi } from '../contexts/ApiContext';

type UseBrandsOptions = Omit<Parameters<typeof useQuery<Brand[]>>[0], 'queryKey' | 'queryFn'> & {
    keepPreviousData?: boolean;
};

export default function useBrands(query = null, opts: UseBrandsOptions = null) {
    const api = useApi();
    const { keepPreviousData = true } = opts || {};
    const { data = null, ...queryResult } = useQuery({
        queryKey: ['brands', query],
        queryFn: ({ queryKey: [, queryParam], signal }) =>
            api.taxonomies.brands(queryParam, null, null, { signal }),
        placeholderData: keepPreviousData ? previousPlaceholder : null,
        ...opts,
    });

    return data !== null
        ? {
              items: data,
              ...queryResult,
          }
        : queryResult;
}
